__turbopack_context__.v({
  "appShell": "page-module__wwMdJG__appShell",
});
